<template>
  <div class="content-block dx-card responsive-paddings">
    <DxToolbar>
      <DxItem :options="dateBoxOptionsStart" location="center" locate-in-menu="auto" widget="dxDateBox" />
      <DxItem :options="dateBoxOptionsEnd" location="center" locate-in-menu="auto" widget="dxDateBox" />
      <DxItem :options="buttonOptionsSearch" location="center" locate-in-menu="never" widget="dxButton" />
    </DxToolbar>
  </div>

  <div class="content-block dx-card responsive-paddings">
    <DxDataGrid id="gridContainer" :ref="gridRefName" :show-borders="true" :show-column-lines="true"
      :columnAutoWidth="true" @exporting="onExporting">
      <DxSearchPanel :visible="true" />
      <DxHeaderFilter :visible="true" />
      <DxScrolling mode="infinite" />
      <DxSorting mode="multiple" />
      <DxExport :enabled="true" />

      <DxColumn data-field="id" caption="사용자 ID" :header-filter="{ allowSearch: true }">
      </DxColumn>

      <DxColumn data-field="name" caption="사용자 이름" :header-filter="{ allowSearch: true }">
      </DxColumn>

      <DxColumn data-field="transTime" caption="날짜" :header-filter="{ allowSearch: true }">
      </DxColumn>

      <DxColumn data-field="action" caption="Action" :header-filter="{ allowSearch: true }">
      </DxColumn>
      
      <DxColumn data-field="spaceId" caption="스페이스 ID" :header-filter="{ allowSearch: true }">
      </DxColumn>

      <DxColumn data-field="spaceName" caption="스페이스 이름" :header-filter="{ allowSearch: true }">
      </DxColumn>

      <DxColumn data-field="mapId" caption="맵 ID" :header-filter="{ allowSearch: true }">
      </DxColumn>

      <DxColumn data-field="mapName" caption="맵 이름" :header-filter="{ allowSearch: true }">
      </DxColumn>

      <DxColumn data-field="objectName" caption="오브젝트 이름" :header-filter="{ allowSearch: true }">
      </DxColumn>

      <DxColumn data-field="x" caption="오브젝트 X 좌표" :header-filter="{ allowSearch: true }">
      </DxColumn>

      <DxColumn data-field="y" caption="오브젝트 Y 좌표" :header-filter="{ allowSearch: true }">
      </DxColumn>

      <DxColumn data-field="isMobile" caption="모바일 접속">
      </DxColumn>

      <DxColumn data-field="isGuest" caption="Guest로 접속">
      </DxColumn>
    </DxDataGrid>
  </div>
</template>

<script>
import DxToolbar, { DxItem } from "devextreme-vue/toolbar";
import {
  DxDataGrid,
  DxScrolling,
  DxColumn,
  DxSorting,
  DxSearchPanel,
  DxHeaderFilter,
  DxExport
} from "devextreme-vue/data-grid";
import fn from "../../utils/function";
import dsu from "../../utils/dataSourceUtils";

var endDate = new Date();
var startDate = new Date();
startDate.setDate(endDate.getDate() - 7);
var defaultStartDate = startDate;
var defaultEndDate = endDate;

export default {
  components: {
    DxToolbar,
    DxItem,
    DxDataGrid,
    DxScrolling,
    DxColumn,
    DxSorting,
    DxSearchPanel,
    DxHeaderFilter,
    DxExport
  },
  data() {
    return {
      gridRefName: 'dataGrid',
      searchCondition: { startDate: defaultStartDate, endDate: defaultEndDate },
      loginHstList: [],
      dateBoxOptionsStart: {
        width: 190,
        value: defaultStartDate,
        text: "시작",
        displayFormat: " 시작 :  yyyy/MM/dd",
        onValueChanged: (args) => {
          this.searchCondition.startDate = args.value;
        }
      },
      dateBoxOptionsEnd: {
        width: 190,
        value: defaultEndDate,
        text: "시작",
        displayFormat: " 종료 :  yyyy/MM/dd",
        onValueChanged: (args) => {
          this.searchCondition.endDate = args.value;
        }
      },
      buttonOptionsSearch: {
        icon: 'search',
        text: '조회',
        stylingMode: "outlined",
        onClick: this.search.bind()
      }
    };
  },
  computed: {
    grid: function () {
      return this.$refs[this.gridRefName].instance;
    }
  },
  methods: {
    search() {
      var params = JSON.parse(JSON.stringify(this.searchCondition));
      params.startDate = dsu.getFormatDate(this.searchCondition.startDate);
      params.endDate = dsu.getFormatDate(this.searchCondition.endDate);

      this.grid.beginCustomLoading();
      dsu.getAxiosOBJGet('/api/AERD/selectPlayerActionHst', params).then(res => {
        let response = res.data;
        if (response.result == 'SUCCESS') {
          this.setGridData(response.data);
        } else {
          fn.notifyError(response.msg);
        }
        this.grid.endCustomLoading();
      });
    },
    onExporting(e) {
      e.fileName = this.$route.meta.transName;
    },
    setGridData(data) {
      this.grid.option('dataSource', data);
    }
  }
};
</script>

<style scoped>
#gridContainer {
  height: calc(100vh - 330px);
}
</style>